<template>
  <div class="container-xl">
    <div
      :class="{
        'bg-light': hasScrolled,
        'bg-opacity': !hasScrolled,
        'fixed-top': hasScrolled,
        'position-absolute': !hasScrolled,
        'start-0': !hasScrolled,
      }"
      class="nav-bar py-4 d-flex justify-content-around justify-content-md-center w-100"
    >
      <router-link to="/campaign/2024techinside" class="logo"
        ><img :src="logoColor" alt="zerone-logo" :style="{ width: logoSize }"
      /></router-link>
      <ul
        class="nav-bar-list d-none d-md-flex ms-5 mb-0 justify-content-evenly align-items-center list-unstyled"
      >
        <li>
          <a
            href="/campaign/2024techinside#section-event-intro"
            class="me-4"
            :class="linkColor"
            >活動簡介</a
          >
        </li>
        <li>
          <a
            href="/campaign/2024techinside#section-event-feature"
            class="me-4"
            :class="linkColor"
            >活動特點</a
          >
        </li>
        <li
          @mouseover="issueDropdownVisible = true"
          @mouseleave="issueDropdownVisible = false"
        >
          <a
            href="/campaign/2024techinside#section-issue"
            class="me-4"
            :class="linkColor"
            >六大應用</a
          >
          <ul
            class="issue-dropdown list-unstyled position-absolute bg-light px-4 pt-4 pb-2 rounded-3"
            v-if="issueDropdownVisible"
          >
            <li v-for="issue in issueInfo" :key="issue.title" class="mb-3">
              <router-link
                :to="issue.link"
                class="d-flex align-items-center"
                @click="issueDropdownVisible = false"
              >
                <div class="bg-secondary p-1 rounded-2 me-1">
                  <img :src="issue.icon" alt="issue" class="icon" />
                </div>
                {{ issue.title }}
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <a
            href="/campaign/2024techinside#section-keynote"
            class="me-4"
            :class="linkColor"
            >專家洞察</a
          >
        </li>
        <li>
          <a
            href="/campaign/2024techinside#section-organizer"
            :class="linkColor"
            >合作夥伴</a
          >
        </li>
      </ul>
      <div class="dropdown-mobile d-md-none position-relative">
        <button class="btn p-0" type="button" @click="openDropdown">
          <i class="bi bi-list fs-1" :class="textColor"></i>
        </button>
      </div>
      <div
        class="dropdown-mobile-menu w-100 h-100 bg-light d-md-none d-flex flex-column align-items-center position-fixed overflow-scroll"
        v-if="mobileDropdownVisible"
      >
        <div
          class="bg-light w-100 dropdown-header d-flex justify-content-around py-4 mb-5"
        >
          <router-link to="/campaign/2024techinside" class="logo"
            ><img :src="logoColor" alt="zerone-logo"
          /></router-link>
          <button
            class="btn p-0 btn-cancel"
            type="button"
            @click="closeDropdown"
          >
            <i class="bi bi-x-lg fs-1 text-dark" :class="textColor"></i>
          </button>
        </div>
        <ul
          class="list-unstyled text-center w-100 my-0 d-flex flex-column"
          @click="closeMobileDropdown"
        >
          <li class="mb-5">
            <a
              class="link-dark"
              href="/campaign/2024techinside#section-event-intro"
              >活動簡介</a
            >
          </li>
          <li class="mb-5">
            <a
              class="link-dark"
              href="/campaign/2024techinside#section-event-feature"
              >活動特點</a
            >
          </li>
          <li class="mb-5">
            <button
              class="btn py-0"
              type="button"
              @click="openCollapseIssues"
              data-bs-toggle="collapse"
              data-bs-target="#collapseExample"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              六大應用
              <i
                class="bi bi-chevron-down ms-2"
                v-if="!issueCollapseVisible"
              ></i>
              <i class="bi bi-chevron-up ms-2" v-else></i>
            </button>
            <div
              class="collapse mt-5"
              :class="{ show: issueCollapseVisible }"
              id="collapseIssues"
            >
              <ul class="list-unstyled text-center w-100 d-flex flex-column">
                <li
                  v-for="issue in issueInfo"
                  :key="issue.title"
                  class="mb-4 fw-light"
                >
                  <router-link
                    :to="issue.link"
                    class="link-dark"
                    @click="closeDropdown"
                  >
                    {{ issue.title }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>
          <li class="mb-5">
            <a class="link-dark" href="/campaign/2024techinside#section-keynote"
              >專家洞察</a
            >
          </li>
          <li class="mb-5">
            <a
              class="link-dark"
              href="/campaign/2024techinside#section-organizer"
              >合作夥伴</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasScrolled: false,
      mobileDropdownVisible: false,
      issueInfo: [
        {
          title: "資訊安全",
          link: "/campaign/issues/security",
          icon: new URL(
            "@/assets/image/security-icon(blue).png",
            import.meta.url
          ).href,
        },
        {
          title: "雲端服務",
          link: "/campaign/issues/cloud-service",
          icon: new URL("@/assets/image/cloud-icon(blue).png", import.meta.url)
            .href,
        },
        {
          title: "儲存與備份系統",
          link: "/campaign/issues/storage-and-backup",
          icon: new URL(
            "@/assets/image/storage-icon(blue).png",
            import.meta.url
          ).href,
        },
        {
          title: "AI大數據",
          link: "/campaign/issues/ai-big-data",
          icon: new URL("@/assets/image/AI-icon(blue).png", import.meta.url)
            .href,
        },
        {
          title: "K8s與虛擬化",
          link: "/campaign/issues/k8s-and-virtualization",
          icon: new URL("@/assets/image/K8s-icon(blue).png", import.meta.url)
            .href,
        },
        {
          title: "IT管理及效能監控",
          link: "/campaign/issues/it-management",
          icon: new URL("@/assets/image/IT-icon(blue).png", import.meta.url)
            .href,
        },
      ],
      issueDropdownVisible: false,
      issueCollapseVisible: false,
    };
  },
  computed: {
    linkColor() {
      return this.hasScrolled ? "link-black" : "link-white";
    },
    textColor() {
      return this.hasScrolled ? "text-dark" : "text-light";
    },
    logoColor() {
      const logoLight = new URL(
        "@/assets/image/zerone logo(white).png",
        import.meta.url
      ).href;
      const logoDark = new URL(
        "@/assets/image/zerone logo(black).png",
        import.meta.url
      ).href;
      if (this.mobileDropdownVisible) return logoDark;
      return this.hasScrolled ? logoDark : logoLight;
    },
    logoSize() {
      return this.hasScrolled ? "180px" : "200px";
    },
  },
  methods: {
    handleNavStatus() {
      this.hasScrolled = window.scrollY > 820;
    },
    openDropdown() {
      this.mobileDropdownVisible = true;
      document.body.classList.add("no-scroll");
    },
    closeDropdown() {
      this.mobileDropdownVisible = false;
      document.body.classList.remove("no-scroll");
    },
    openCollapseIssues() {
      if (this.issueCollapseVisible) {
        this.issueCollapseVisible = false;
        return;
      }
      this.issueCollapseVisible = true;
    },
    closeMobileDropdown(event) {
      if (event.target.tagName === "A") {
        this.mobileDropdownVisible = false; // 关闭下拉菜单
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleNavStatus);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleNavStatus);
  },
};
</script>

<style lang="scss">
.nav-bar {
  z-index: 8;

  .logo {
    z-index: 9;
  }

  // img {
  //   width: 200px;
  // }

  .link-white {
    color: #fff;
  }

  .link-black {
    color: #000;
  }
  .nav-bar-list {
    width: 55%;

    .issue-dropdown {
      left: 56%;
      box-shadow: 0 4px 20px #00000026;

      img {
        height: 20px;
        width: 20px;
      }
    }
  }

  a {
    transition: color 0.3s ease-in-out;
  }
  a:hover {
    color: #27a1d8;
  }
}

.bg-opacity {
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  );
}

.bg-change {
  background-color: white;
}

.dropdown-mobile {
  z-index: 9;

  .btn-cancel {
    z-index: 10;
    left: -35px;
  }
}

.dropdown-mobile-menu {
  z-index: 10;
  top: 0px;

  ul {
    height: 80%;
    z-index: 1;
  }

  .dropdown-header {
    z-index: 2;
  }
}

.no-scroll {
  overflow: hidden;
  height: 100%;
}
</style>
